"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../icons/FontAwesome");
var TableMenuIsLocked = /** @class */ (function (_super) {
    __extends(TableMenuIsLocked, _super);
    function TableMenuIsLocked(props) {
        var _this = _super.call(this, props) || this;
        _this.action_lock_true = "lock:true";
        _this.action_lock_false = "lock:false";
        return _this;
    }
    TableMenuIsLocked.prototype.doLockAction = function (e, RecordKey, RecordTitle) {
        var _lock = false;
        if (e.key == this.action_lock_true) {
            _lock = true;
        }
        if (this.props.onLockClick) {
            this.props.onLockClick(RecordKey, RecordTitle, _lock);
        }
    };
    TableMenuIsLocked.prototype.getDropDownLink = function (record) {
        if (record.locked) {
            return (React.createElement("a", { className: "ant-dropdown-link", style: { color: "#FF0000" }, href: "#" },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "lock" }),
                " ",
                this.props.lockedTexts.text,
                " ",
                React.createElement(FontAwesome_1.FA, { right: true, icon: "chevron-down" })));
        }
        else {
            return (React.createElement("a", { className: "ant-dropdown-link", href: "#" },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "lock-open" }),
                " ",
                this.props.unlockedTexts.text,
                " ",
                React.createElement(FontAwesome_1.FA, { right: true, icon: "chevron-down" })));
        }
    };
    TableMenuIsLocked.prototype.getIsLockedDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doLockAction(e, record.key, record.title); } },
            React.createElement(antd_1.Menu.Item, { key: this.action_lock_false, disabled: !record.locked },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "lock-open" }),
                this.props.unlockedTexts.menu),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: this.action_lock_true, disabled: record.locked },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "lock" }),
                this.props.lockedTexts.menu)));
    };
    TableMenuIsLocked.prototype.render = function () {
        return (React.createElement(antd_1.Dropdown, { overlay: this.getIsLockedDropDownMenu(this.props.record), trigger: ['click'] }, this.getDropDownLink(this.props.record)));
    };
    return TableMenuIsLocked;
}(React.Component));
exports.default = TableMenuIsLocked;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/table_menus/TableMenuIsLocked.tsx
// module id = 35
// module chunks = 0